export default __webpack_public_path__ + "static/media/circle4.b5217bd8.png";